
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/technology",
      function () {
        return require("private-next-pages/partners/technology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/technology"])
      });
    }
  